export function parseApiError(error, fallback = "Something went wrong") {
  const data = error?.response?.data || {};
  const list = Array.isArray(data.errors) ? data.errors : [];
  const firstErrorMessage = list[0]?.message;

  // Surface rate-limited / plan-gated error messages from the backend
  const errorMessage = data.error || data.message || error?.message || fallback;

  // If the backend returned a structured error code, prefix it for clarity
  const code = data.code || "";
  if (code === "RATE_LIMITED") {
    return `⏳ ${errorMessage}`;
  }
  if (code === "PLAN_FEATURE_REQUIRED") {
    return `🔒 ${errorMessage}`;
  }

  return firstErrorMessage || errorMessage;
}

export function isAuthError(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.code;
  return status === 401 || status === 403 || code === "AUTH_REQUIRED" || code === "AUTH_INVALID";
}

export function isRateLimitedError(error) {
  return error?.response?.data?.code === "RATE_LIMITED" || error?.response?.status === 429;
}

export function extractErrorCode(error) {
  return error?.response?.data?.code || null;
}